module.exports = __webpack_public_path__ + "img/icon_managerOffical.735e1355.png";